export const useExpandableList = () => {
  const isAllShown = ref<boolean>(false);

  const show = () => {
    isAllShown.value = true;
  };
  const hide = () => {
    isAllShown.value = false;
  };

  return { isAllShown, show, hide };
};
